// src/App.js
import React, { useRef, createContext, useState } from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./Navbar";
import Home from "./home";
import Services from "./service";
import Pricing from "./pricing";
import Contact from "./contact";
import Footer from "./footer";
import AboutUs from "./aboutUs";
import Terms from "./terms";
import Privacy from "./privacy";

// --- Context Setup ---
export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);

  // Add a new message
  const addMessage = (name, email, message) => {
    const newMessage = {
      id: Date.now(),
      name,
      email,
      message,
      time: new Date().toLocaleString(),
    };
    setMessages((prev) => [...prev, newMessage]);
  };

  return (
    <AuthContext.Provider value={{ messages, addMessage }}>
      {children}
    </AuthContext.Provider>
  );
};

// --- Main App ---
function App() {
  const homeRef = useRef(null);
  const servicesRef = useRef(null);
  const pricingRef = useRef(null);
  const contactRef = useRef(null);

  const sections = {
    home: homeRef,
    services: servicesRef,
    pricing: pricingRef,
    contact: contactRef,
  };

  return (
    <AuthProvider>
      <Routes>
        {/* Main Website */}
        <Route
          path="/"
          element={
            <div className="App">
              <Navbar sections={sections} />
              <main>
                <Home ref={homeRef} />
                <Services ref={servicesRef} />
                <Pricing ref={pricingRef} />
                <AboutUs />
                <Contact ref={contactRef} />
              </main>
              {/* ✅ Pass sections to Footer */}
              <Footer sections={sections} />
            </div>
          }
        />

        {/* Legal Pages */}
        <Route
          path="/terms"
          element={
            <div className="App">
              <Navbar sections={sections} />
              <main>
                <Terms />
              </main>
              <Footer sections={sections} />
            </div>
          }
        />
        <Route
          path="/privacy"
          element={
            <div className="App">
              <Navbar sections={sections} />
              <main>
                <Privacy />
              </main>
              <Footer sections={sections} />
            </div>
          }
        />
      </Routes>
    </AuthProvider>
  );
}

export default App;
